/* React */
import React from "react";

/* Ionic */
import { IonButton } from "@ionic/react";

/* Stylesheet */
import styles from "./OutlineButton.module.scss";

/* Interfaces */
interface OutlineButtonProps {
  scssProps?: ScssProps;
  label: string;
  disabled: boolean;
  onClick?: () => void;
}

interface ScssProps {
  margin?: string;
  color?: string;
  textTransform?: "uppercase" | "none";
}

const OutlineButton: React.FC<OutlineButtonProps> = ({
  scssProps,
  label,
  disabled,
  onClick,
}) => {
  return (
    <IonButton
      style={{
        margin: scssProps?.margin,
        color: scssProps?.color,
        border: `1px solid ${scssProps?.color}`,
        textTransform: scssProps?.textTransform,
      }}
      className={styles.outline_button}
      disabled={disabled}
      onClick={onClick}
    >
      {label}
    </IonButton>
  );
};

export default OutlineButton;
